import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveInactiveCategory,
  createCategory,
  deleteCategory,
  getAllActiveCategory,
  getAllCategory,
  getCategoryByID,
  updateCategory,
} from "./services/category.services";

export interface ICategoryState {
  loading: boolean;
  formloading: boolean;
  error: string;
  CategoryID: number | null;
  CategoryList: ICategory[];
  CategoryDetail: ICategoryDetails;
}

export interface ICategoryDetails {
  ID?: number | null;
  Name: string;
  CategoryURL: string;
  Image: string;
  IsActive: number | boolean;
}
export interface ICategory {
  Name: string;
  CategoryURL: string;
  Image: string;
  IsActive: number | boolean;
}

const initialState: ICategoryState = {
  loading: false,
  formloading: false,
  error: "",
  CategoryID: null,
  CategoryList: [],
  CategoryDetail: {
    Name: "",
    Image: "",
    CategoryURL: "",
    IsActive: 1,
  },
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    clearCategoryDetails: (state) => {
      state.CategoryDetail = initialState.CategoryDetail;
    },
    setCategoryID: (state, action) => {
      state.CategoryID = action.payload;
    },
    clearCategoryID: (state) => {
      state.CategoryID = initialState.CategoryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCategory.fulfilled,
      (state, action: PayloadAction<ICategory[]>) => {
        state.loading = false;
        state.CategoryList = action.payload || [];
      }
    );
    builder.addCase(getAllCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CategoryList = [];
    });
    builder.addCase(createCategory.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createCategory.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createCategory.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCategory.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateCategory.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCategoryByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getCategoryByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.CategoryDetail = action.payload;
    });
    builder.addCase(getCategoryByID.rejected, (state, action) => {
      state.formloading = false;
      state.CategoryDetail = initialState.CategoryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCategory.fulfilled,
      (state, action: PayloadAction<ICategory[]>) => {
        state.loading = false;
        state.CategoryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CategoryList = [];
    });
    builder.addCase(ActiveInactiveCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCategoryDetails, clearCategoryID, setCategoryID } =
  categorySlice.actions;
export default categorySlice.reducer;
